import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { isPresent } from "./helpers";

export default function CTASection({ cta }) {
  if (!cta) return null;
  if (
    !isPresent(cta.title) &&
    !isPresent(cta.description) &&
    !isPresent(cta.button_text)
  )
    return null;

  return (
    <section
      data-testid="cta-section"
      className="py-24 md:py-32 relative overflow-hidden transition-colors duration-300"
      style={{
        background:
          "linear-gradient(135deg, var(--dvx-primary) 0%, var(--dvx-primary-dark) 100%)",
      }}
    >
      {/* Subtle texture overlays */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 50%, white 1px, transparent 1px), radial-gradient(circle at 80% 20%, white 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-[120px]" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-black/10 rounded-full blur-[100px]" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {isPresent(cta.title) && (
            <h2 className="font-oswald text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase tracking-tight">
              {cta.title}
            </h2>
          )}
          {isPresent(cta.description) && (
            <p className="mt-6 text-white/80 font-manrope text-lg max-w-2xl mx-auto">
              {cta.description}
            </p>
          )}
          {isPresent(cta.button_text) && isPresent(cta.button_href) && (
            <div className="mt-10">
              <Link to={cta.button_href}>
                <Button
                  data-testid="cta-join-btn"
                  className="rounded-none px-10 py-6 bg-white text-[var(--dvx-primary)] font-oswald font-bold text-xl uppercase tracking-widest border-2 border-white hover:bg-transparent hover:text-white transition-all duration-300"
                >
                  {cta.button_text} <ArrowRight className="ml-3" size={24} />
                </Button>
              </Link>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
